import * as CubeTree from '../../cubeTree';
import * as UIToolkit from '../../UIToolkit';
import Utils from '../../utils/util';
import { getColWidth } from './getColWidth';

function findColsInTargetWidth(freezers: CubeId[], width: PhysicsMeasurement): CubeId[][] {
    let cols: CubeId[][] = [];
    let allCubes: CubeId[] = CubeTree.findCubesInTargetFreezers(freezers);
    let allCols: CubeId[][] = UIToolkit.makeSkuCubesColGroupList(allCubes);

    if (width <= 0) {
        return cols;
    }

    for (let i = 0; i < allCols.length; i++) {
        let colWidth: PhysicsMeasurement = getColWidth(allCols[i]);
        let half: PhysicsMeasurement = Utils.math(colWidth, 2, '/');

        if (half <= width) {
            cols.push(allCols[i]);
            width = Utils.math(width, colWidth, '-');
            continue;
        }

        break;
    }

    return cols;
}

export {
    findColsInTargetWidth
};
